
const digest = '14d42bb41ac56c6c493059146c68aeb57c5824c4badf4cf961e885e0f564a7c8';
const classes = {"item":"_item_pnuyf_1","content":"_content_pnuyf_21","title":"_title_pnuyf_25","subtitle":"_subtitle_pnuyf_28"};
const css = `._item_pnuyf_1 {
  background: #ffffff;
  border-radius: 15px;
  padding: 14px 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  min-height: 76px;
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: 1px solid #ffffff;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}
._item_pnuyf_1:hover {
  border: 1px solid rgba(0, 84, 188, 0.2);
  background-color: #f3f5ff;
}
._item_pnuyf_1 ._content_pnuyf_21 {
  display: flex;
  flex-direction: column;
}
._item_pnuyf_1 ._content_pnuyf_21 ._title_pnuyf_25 {
  font-weight: 600;
}
._item_pnuyf_1 ._content_pnuyf_21 ._subtitle_pnuyf_28 {
  font-size: 12px;
}
._item_pnuyf_1 img {
  height: 25px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  